var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercardCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 20,
    viewBox: "0 0 30 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 20,
    rx: 2,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.704 5.32147H12.2959V15.04H17.704V5.32147Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6395 10.1807C12.6386 9.24471 12.8507 8.32082 13.2597 7.47895C13.6687 6.63708 14.2639 5.89929 15.0002 5.32143C14.0884 4.60475 12.9934 4.15906 11.8403 4.0353C10.6872 3.91154 9.5225 4.11469 8.4794 4.62155C7.4363 5.12841 6.55685 5.91852 5.94157 6.90157C5.32628 7.88462 5 9.02095 5 10.1807C5 11.3404 5.32628 12.4767 5.94157 13.4598C6.55685 14.4428 7.4363 15.2329 8.4794 15.7398C9.5225 16.2467 10.6872 16.4498 11.8403 16.326C12.9934 16.2023 14.0884 15.7566 15.0002 15.0399C14.2639 14.4621 13.6687 13.7243 13.2597 12.8824C12.8507 12.0405 12.6387 11.1166 12.6395 10.1807Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0003 10.1807C25.0004 11.3404 24.6741 12.4767 24.0589 13.4598C23.4436 14.4428 22.5642 15.2329 21.5211 15.7398C20.4781 16.2466 19.3134 16.4498 18.1603 16.326C17.0072 16.2023 15.9122 15.7566 15.0005 15.0399C15.7361 14.4615 16.3308 13.7236 16.7397 12.8818C17.1487 12.0401 17.3611 11.1165 17.3611 10.1807C17.3611 9.24486 17.1487 8.32126 16.7397 7.47952C16.3308 6.63778 15.7361 5.89987 15.0005 5.32143C15.9122 4.60475 17.0072 4.15906 18.1603 4.0353C19.3134 3.91154 20.4781 4.1147 21.5211 4.62156C22.5642 5.12843 23.4436 5.91854 24.0589 6.90159C24.6741 7.88464 25.0004 9.02096 25.0003 10.1807Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4102 14.0106V13.8116H24.4905V13.7711H24.2861V13.8116H24.3664V14.0106H24.4102ZM24.8069 14.0106V13.7707H24.7443L24.6722 13.9357L24.6002 13.7707H24.5375V14.0106H24.5817V13.8296L24.6493 13.9856H24.6952L24.7627 13.8292V14.0106H24.8069Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardCardIcon);
export default __webpack_public_path__ + "static/media/mastercard-card-icon.196f4a886f80be4180390f678df46acb.svg";
export { ForwardRef as ReactComponent };